import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Component, OnDestroy, OnInit } from '@angular/core';
import * as AppActions from '@app/store/actions/app.actions';
import { SeoService } from '@app/modules/core/services/seo.service';
import { selectAppState } from '@app/store/selectors/app.selectors';
import { CoreService } from '@app/modules/core/services/core.service';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { FAQCategories } from '@app/modules/core/services/faqs.service';
import { FunctionsService } from '@app/modules/core/services/functions.service';
import { UserQrGeneratorService } from '@app/modules/user/services/user-qr-generator.service';
import { AlaCarteProductInterface, AlaCarteQrTypes, QrGeneratorNavigatorCategories } from 'shared-library';

declare const bootstrap: any

@Component({
  selector: 'app-core-products-wrapper',
  templateUrl: './core-products-wrapper.component.html',
  styleUrls: ['./core-products-wrapper.component.scss']
})
export class CoreProductsWrapperComponent implements OnInit, OnDestroy {

  appState$ = this.store.select(selectAppState);

  session_info: SessionInfo
  qr_category: AlaCarteQrTypes
  products: AlaCarteProductInterface[]
  private subscriptions: Subscription[] = []

  faq_category = FAQCategories.ALACARTE_MEMORIES
  qr_categories = {
    MEMORIES: QrGeneratorNavigatorCategories.MEMORIES
  }

  modal_element: any
  readonly memories_modal_id: "memories_modal_id"
  private readonly memories_video_src = "https://www.youtube.com/embed/KXAtGVkEQDY?si=yXOHGADIrg7MULWi&controls=1&rel=0"
  memories_video_src_1 = ""

  constructor(
    private store: Store,
    private router: Router,
    private seo: SeoService,
    public device: DeviceDetectorService,
    private activatedRoute: ActivatedRoute,
    public readonly coreService: CoreService,
    public readonly functionService: FunctionsService,
    public readonly qrGeneratorService: UserQrGeneratorService,
  ) {
    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => this.session_info = si))
    this.subscriptions.push(this.appState$.subscribe(ls => this.products = ls.data.cache.products.alacarte.memories))
  }

  ngOnInit(): void {
    this.subscriptions.push(this.activatedRoute.params.subscribe(params => {
      this.qr_category = params['qr_category']
      if (![QrGeneratorNavigatorCategories.MEMORIES].includes(this.qr_category)) this.router.navigateByUrl("/404")
      this.seo.generateMetaTags(this.qr_category)
      this.products = null
      this.getProducts()
    }));
    this.getResources()
    this.functionService.initializeTooltip()
  }

  ngOnDestroy(): void {
    this.subscriptions.map(sub => sub.unsubscribe())
  }

  openModal(id = this.memories_modal_id) {
    const modal_dom_element = document.getElementById(id)
    this.modal_element = new bootstrap.Modal(modal_dom_element, {
      keyboard: false
    })
    this.modal_element.show()

    if (id === this.memories_modal_id) {
      this.memories_video_src_1 = this.memories_video_src
      modal_dom_element.addEventListener('hidden.bs.modal', () => {
        this.memories_video_src_1 = ""
      })
    }


  }

  async getProducts() {
    this.store.dispatch(AppActions.fetchAlaCartePrices({ qr_category: this.qr_category, force: true }))
  }

  async getResources() {
    let _changed = false
    if (_changed) {
      this.coreService.setSessionData(this.session_info, false)
    }
  }
}
